import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import SearchBar from "components/base/SearchBar";
import { InlineSpinner } from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { ODOO_SAVE_CUSTOMER } from "./graphql";

const ConnectRetailerDeliveryAddressView = ({ order, options, hide }) => {
  const [searchText, setSearchText] = useState("");
  const [saveCustomer, saveCustomerRes] = useMutation(ODOO_SAVE_CUSTOMER, {
    onCompleted() {
      Alert("success", "Customer connected successfully");
      hide();
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: ["FETCH_MT_ODOO_RETAILERS"],
    awaitRefetchQueries: true,
  });

  console.log("order", order);

  function onSelectHandler(address) {
    if (window.confirm("Are you sure you want to connect this customer?")) {
      saveCustomer({
        variables: {
          instance: "INC",
          id: address.id,
          xStudioMtAddressId: order.retailerShipToID,
        },
      });
    }
  }

  const finalOptions = options.filter((option) =>
    option.contact_address_inline
      .toLowerCase()
      .includes(searchText.toLowerCase()),
  );

  return (
    <div className="text-sm">
      {saveCustomerRes.loading ? (
        <InlineSpinner text="Connecting address..." />
      ) : options.length === 0 ? (
        <div className="mt-4 text-red-600">
          ⚠️ No available delivery address for this customer in odoo. Make sure
          this customer has delivery address in odoo and try again.
        </div>
      ) : (
        <div>
          <div>
            <SearchBar value={searchText} onChange={setSearchText} />
          </div>

          <div className="-mx-2 mt-4">
            <table>
              <tbody>
                {finalOptions.map((option) => (
                  <tr
                    key={option.id}
                    className="border-y cursor-pointer hover:text-sky-600"
                    onClick={() => onSelectHandler(option)}
                  >
                    <td>{option.contact_address_inline}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConnectRetailerDeliveryAddressView;
